// utils/cargarConfig.js — carga de /api/config con reintentos (H1, 23-sep-2026).
// Extraído de App.js para poder probarlo: la config del panel se carga UNA vez
// por sesión y TODOS los gates de pantalla (menú, toggle de Analítica, flags)
// leen de acá.
//
// CAUSA RAÍZ del bug H1 (toggle apagado con el flag encendido en el servidor):
// la ventana del ejecutable abre ANTES de que el backend termine de arrancar
// (initDB corre antes de app.listen), el único fetch de /api/config moría por
// conexión y el catch fijaba config={} — que la pantalla lee como «todos los
// flags apagados» — sin reintento ni distinción de «no cargó». El servidor,
// ya arriba, servía el flag guardado: pantalla y servidor se contradecían.
//
// Reglas que fija este módulo (suite cargarConfig.test.js):
//   • se REINTENTA (error de red y respuesta no-ok) con backoff hasta traer la
//     config real — nunca se resuelve a un objeto fabricado;
//   • cancelar (desmontaje) devuelve null: «no cargó» es distinguible de
//     «cargó con flags apagados».
export async function cargarConfigConReintentos(hacerFetch, {
  delayMs = 1500,
  maxDelayMs = 10000,
  cancelado = () => false,
  esperar = (ms) => new Promise((r) => setTimeout(r, ms)),
} = {}) {
  let espera = delayMs;
  for (;;) {
    if (cancelado()) return null;
    try {
      const r = await hacerFetch();
      if (r && r.ok) return await r.json();
    } catch {
      // backend arrancando o red caída: se reintenta abajo
    }
    if (cancelado()) return null;
    await esperar(espera);
    espera = Math.min(espera * 2, maxDelayMs);
  }
}
